import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  show(event) {
    event.preventDefault()
    event.stopPropagation()

    // 创建全屏遮罩
    const overlay = document.createElement("div")
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      cursor: zoom-out;
    `

    // 创建图片
    const img = document.createElement("img")
    img.src = this.urlValue
    img.style.cssText = `
      max-width: 90%;
      max-height: 90%;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.5);
      background: white;
      padding: 10px;
    `

    overlay.appendChild(img)
    document.body.appendChild(overlay)

    // 点击遮罩关闭
    overlay.onclick = () => {
      overlay.remove()
    }

    // 按下 ESC 键关闭
    document.onkeydown = (e) => {
      if (e.key === "Escape") overlay.remove()
    }
  }
}
